import { ForwardedRef, RefObject } from 'react';

export default function subscribeToResize(
  ref: RefObject<any> | ForwardedRef<any>,
  callback: (string: number) => void
) {
  if (ref && typeof ref !== 'function') {
    const resizeObserver = new ResizeObserver(() => {
      ref.current && callback(ref.current.offsetHeight);
    });

    ref.current && resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect();
  }

  return () => null;
}
